import { useSizingPageModalContext } from '../contexts/SizingPageModalProvider';
import SizeGuideModal from './SizeGuideModal';

const Gen4SizeGuideModal = () => {
  const { or4SizeGuideVisible, setOr4SizeGuideVisible, setOr4VideoVisible } =
    useSizingPageModalContext();
  const toggleModal = () => {
    setOr4SizeGuideVisible(false);
  };
  const onWatchVideoClick = () => {
    setOr4VideoVisible(true);
  };

  return (
    <SizeGuideModal
      description="or4_sizing_tips_subtitle"
      isOpen={or4SizeGuideVisible}
      onWatchVideoClick={onWatchVideoClick}
      steps={[
        {
          content: ['or4_sizing_tips_choose_finger_copy'],
          title: 'sizing_choose_finger_title',
        },
        {
          content: [
            'or4_sizing_tips_test_fit_copy_p1',
            'or4_sizing_tips_test_fit_copy_p2',
          ],
          title: 'sizing_test_fit_title',
        },
        {
          content: ['sizing_tips_confirm_size_copy'],
          cta: {
            href: '/my-account',
            label: 'confirm_your_size',
            size: 'large',
            variant: 'secondary-dark',
          },
          title: 'confirm_your_size',
        },
      ]}
      title="or4_sizing_tips_title"
      toggleModal={toggleModal}
    />
  );
};

export default Gen4SizeGuideModal;
